import { Stack } from '@mui/material'
import React from 'react'

import CO2eCalculatorLink from '@app/src/components/Navigation/VerticalMenu/NavigationItems/CO2eCalculatorLink'
import ExpectationsLink from '@app/src/components/Navigation/VerticalMenu/NavigationItems/ExpectationsLink'
import {
  AccountTreeOutlined,
  AssessmentOutlined,
  BarChartOutlined,
  BusinessOutlined,
  CalculateOutlined,
  DescriptionOutlined,
  HomeOutlined,
  InboxOutlined,
  InsightsOutlined,
  PublishedWithChangesOutlined,
  RouteOutlined,
  ShoppingBagOutlined,
} from '@mui/icons-material'
import AnalyzeMenu from './AnalyzeMenu'
import AssessmentMenu from './AssessmentMenu'
import DashboardLink from './DashboardLink'
import ProductsMenu from './ProductsMenu'
import ProviderMenu from './ProviderMenu'
import RecommendedJourneyLink from './RecommendedJourneyLink'
import RequestMenu from './RequestMenu'
import SavedViewsMenu from './SavedViewsMenu'
import SubscriptionLink from './SubscriptionLink'
import SustainabilityProfileLink from './SustainabilityProfileLink'
import SustainabilityReportMenu from './SustainabilityReportMenu'
import TransparencyProductMenu from './TransparencyProductMenu'

export interface NavigationItemProps {
  icon?: React.ReactNode
}

const NavigationItems = (): JSX.Element => (
  <Stack>
    <DashboardLink icon={<HomeOutlined fontSize="small" />} />
    <ProviderMenu icon={<BusinessOutlined fontSize="small" />} />
    <AssessmentMenu icon={<AssessmentOutlined fontSize="small" />} />
    <RecommendedJourneyLink icon={<RouteOutlined fontSize="small" />} />
    <RequestMenu icon={<InboxOutlined fontSize="small" />} />
    <ExpectationsLink icon={<PublishedWithChangesOutlined fontSize="small" />} />
    <AnalyzeMenu icon={<BarChartOutlined fontSize="small" />} />
    <ProductsMenu icon={<AccountTreeOutlined fontSize="small" />} />
    <SustainabilityReportMenu icon={<DescriptionOutlined fontSize="small" />} />
    <SubscriptionLink icon={<BusinessOutlined fontSize="small" />} />
    <TransparencyProductMenu icon={<ShoppingBagOutlined fontSize="small" />} />
    <SustainabilityProfileLink icon={<InsightsOutlined fontSize="small" />} />
    <CO2eCalculatorLink icon={<CalculateOutlined fontSize="small" />} />
    <SavedViewsMenu />
  </Stack>
)

export default NavigationItems
